module.exports = __webpack_public_path__ + "static/img/profile-assing.45f8cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile-assing.png
// module id = j3Bp
// module chunks = 1